import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Icon } from "rhombus-react";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import moment from "moment";
import { DATE_AND_TIME_FORMAT } from "utils/constants";
import { FEED_RUN_STATUS, FEED_RUN_STATUS_CONFIG } from "utils/FeedRunStatus";

import "./LastUpdatedCell.css";

function formatLastUpdatedDate(dateValue) {
	const date = moment(dateValue);
	const now = moment();
	const isToday = date.isSame(now, 'day');

	if (isToday) {
		return `Today at ${date.format('h:mm A')}`;
	}

	return date.format(DATE_AND_TIME_FORMAT);
}

export default function LastUpdatedCell({ value, dependentValues = {} }) {
	const { lastUpdateStatus, contentFeedId, contentFeedName, libraryId } = dependentValues;
	const dispatch = useDispatch();

	useTooltipRebuild(value);

	if (!value) {
		return null;
	}

	const formattedDate = formatLastUpdatedDate(value);
	const statusConfig = FEED_RUN_STATUS_CONFIG[lastUpdateStatus];
	const tooltip = lastUpdateStatus === FEED_RUN_STATUS.ERROR ? "<div style='text-align:center'>Error<br/>Click for more details</div>" : statusConfig?.label;

	const handleClick = () => {
		dispatch(push({
			pathname: `/library/${libraryId}/content-feeds/${contentFeedId}/updates-history/`,
			state: { contentFeedName },
		}));
	};

	return (
		<div className="last-updated-cell last-updated-cell-clickable" onClick={handleClick}>
			{statusConfig && (
				<Icon
					name={statusConfig.iconClass}
					className={`last-updated-status-icon last-updated-status-${lastUpdateStatus}`}
					data-tip={tooltip}
					data-html={true}
				/>
			)}
			<span className="last-updated-date">{formattedDate}</span>
		</div>
	);
}

LastUpdatedCell.displayName = "LastUpdatedCell";

LastUpdatedCell.propTypes = {
	value: PropTypes.string,
	dependentValues: PropTypes.shape({
		lastUpdateStatus: PropTypes.oneOf(Object.values(FEED_RUN_STATUS)),
		contentFeedId: PropTypes.number,
		contentFeedName: PropTypes.string,
		libraryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	}),
};
